var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "scroll-number-item",
      style: { width: _vm.itemWidth + "px", height: _vm.inHeight + "px" },
    },
    [
      _c(
        "div",
        {
          ref: "list",
          staticClass: "scroll-list",
          style: Object.assign({}, _vm.listStyle, _vm.overrideStyle),
        },
        [
          _c(
            "ul",
            { staticClass: "number-list padding-number-list" },
            _vm._l(_vm.backwardPaddingNumbers, function (num, index) {
              return _c("li", { key: "real-" + index }, [
                _c(
                  "div",
                  { staticClass: "number-item", style: _vm.itemStyle },
                  [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.numbers[index] +
                            _vm.numbers.length -
                            _vm.backwardPaddingNumbers.length
                        )
                      ),
                    ]),
                  ]
                ),
              ])
            }),
            0
          ),
          _c(
            "ul",
            { ref: "realList", staticClass: "number-list" },
            _vm._l(_vm.numbers, function (num, index) {
              return _c("li", { key: "real-" + index }, [
                _c(
                  "div",
                  { staticClass: "number-item", style: _vm.itemStyle },
                  [_c("span", [_vm._v(_vm._s(num))])]
                ),
              ])
            }),
            0
          ),
          _c(
            "ul",
            { staticClass: "number-list padding-number-list" },
            _vm._l(_vm.forwardPaddingNumbers, function (num, index) {
              return _c("li", { key: "real-" + index }, [
                _c(
                  "div",
                  { staticClass: "number-item", style: _vm.itemStyle },
                  [_c("span", [_vm._v(_vm._s(num))])]
                ),
              ])
            }),
            0
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }